import { Shortcut, SidebarTitle, VerticalSpacer } from "components/Layout";
import { ResourceList, Section } from "components/content/Section";
import { IDraggableAlignmentResultSection, ISectionGroup, SectionGroup } from "store/types";
import exclude from "../../components/content/icons/exclude.svg";
import { DraggableLocation, Droppable } from "@hello-pangea/dnd";
import { EmptyGroupPlaceholder } from "./EmptyGroupPlaceholder";
import { isEmpty } from "lodash";
import { Grid } from "@mui/material";

interface IProps {
  state: any;
  onMoveResourceViaMenu: (source: DraggableLocation, destination: DraggableLocation, draggableId: string[]) => any;
}

export const Exclude = ({ state, onMoveResourceViaMenu }: IProps) => {
  const sectionGroup =
    state &&
    state.sectionGroups &&
    state.sectionGroups.find((sectionGroup: ISectionGroup) => sectionGroup.name === SectionGroup.EXCLUDED);
  if (sectionGroup) {
    return (
      <div
        style={{
          border: "2px solid #E2221B",
          padding: 16,
          backgroundColor: "white",
          margin: 16,
        }}
      >
        <Grid container spacing={0}>
          <Grid item xs={1} style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
            <img style={{ height: "20px" }} src={exclude} alt="" title="Excluded" />
          </Grid>
          <Grid item xs={9} style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
            <SidebarTitle>Exclude</SidebarTitle>
          </Grid>
          <Grid item xs={2} style={{ display: "flex", justifyContent: "right", alignItems: "center" }}>
            <Shortcut>E</Shortcut>
          </Grid>
        </Grid>
        &nbsp;
        {isEmpty(sectionGroup.sections) && (
          <Droppable droppableId="exclude">
            {(provided: any, snapshot: any) => (
              <ResourceList
                ref={provided.innerRef}
                {...provided.droppableProps}
                isdraggingover={`${snapshot.isDraggingOver}`}
                sidebar="true"
              >
                <VerticalSpacer />
                <EmptyGroupPlaceholder color="#EEEEEE" text="No content will be excluded." />
              </ResourceList>
            )}
          </Droppable>
        )}
        {sectionGroup.sections.map((section: IDraggableAlignmentResultSection, index: number) => {
          const resources = section.resourceIds.map((uid: any) =>
            state.resources.find((resource: any) => resource.uid === uid),
          );
          return (
            <Section
              key={section.uid}
              state={state}
              section={section}
              resources={resources}
              onMoveResourceViaMenu={onMoveResourceViaMenu}
              expand={false}
              sidebar={true}
              shortcut={index === 0 ? ["e", "E"] : undefined}
            />
          );
        })}
      </div>
    );
  } else return null;
};
